<template>
  <Modal
    v-bind="$attrs"
    :title="computedTitle"
    @close="$emit('close')"
    @modalStatus="modalStatus = $event"
  >
    <div slot="header-right" v-if="!showLogin">
      <v-btn
        fab
        small
        text
        @click="getLicencas"
        :class="{ 'mr-3': $vuetify.breakpoint.smAndUp }"
        :loading=loading
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-btn fab small text @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div slot="inner-body" class="pt-5">
      <template v-if="showLogin">
        <v-form
          v-model="valid"
          ref="loginForm"
          lazy-validation
          @submit.prevent="handleLogin"
        >
          <v-text-field
            v-model="email"
            label="E-mail"
            name="login"
            prepend-inner-icon="mdi-account"
            type="text"
            outlined
            spellcheck="false"
            :rules="[rules.required, rules.email]"
            required
          ></v-text-field>

          <v-text-field
            v-model="password"
            id="password"
            label="Senha"
            name="password"
            prepend-inner-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            :type="showPassword ? 'text' : 'password'"
            outlined
            :rules="[rules.required]"
            required
          ></v-text-field>
          <v-row>
            <v-col class="py-0">
              <v-btn text block @click="cancelLogin">Cancelar</v-btn>
            </v-col>
            <v-col class="py-0">
              <v-btn
                type="submit"
                block
                color="primary"
                :loading="loading"
                :disabled="!valid"
              >Entrar</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </template>
      <template v-else-if="!showLogin && usuario_licencas && usuario_licencas.length">
        <ListItemSelect
          v-for="licenca of usuario_licencas"
          :key="licenca.id_licenca"
          :title="licenca.titulo"
          :disabled="isLicencaAtual(licenca.id_licenca)"
          @itemClicked="selectToken(licenca.id_licenca)"
        />
      </template>
      <template v-else>
        <Alert text="Nenhuma licença encontrada" />
      </template>
    </div>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from './Modal2';
import ListItemSelect from './list/ListItemSelect';
import Alert from './Alert';

export default {
  name: 'ModalLicencaSelect',
  components: {
    Modal,
    ListItemSelect,
    Alert
  },
  data: () => ({
    modalStatus: null,
    valid: true,
    showLogin: false,
    showPassword: false,
    email: '',
    password: '',
    id_licenca: ''
  }),
  watch: {
    modalStatus(value) {
      if (value && (!this.usuario_licencas || (this.usuario_licencas && !this.usuario_licencas.length))) {
        this.getLicencas();
      }
    }
  },
  computed: {
    ...mapGetters(['usuario_licenca', 'usuario_licencas', 'usuario_tokens', 'rules', 'loading']),
    computedTitle() {
      return this.showLogin ? 'Informe seu e-mail e senha' : 'Selecione a licença';
    }
  },
  methods: {
    ...mapActions(['silentRefresh', 'login', 'getUsuarioLicencas']),
    getLicencas() {
      this.getUsuarioLicencas();
    },
    cancelLogin() {
      this.showLogin = false;
      this.email = '';
      this.password = '';
      this.id_licenca = '';
    },
    isLicencaAtual(id_licenca) {
      return this.usuario_licenca.id_licenca === id_licenca;
    },
    async selectToken(id_licenca) {
      this.id_licenca = id_licenca;

      const tokens = this.usuario_tokens;

      const tokenExistente = tokens.find(token => token.id_licenca === id_licenca);

      if (!tokenExistente) return this.showLogin = true;

      const response = await this.silentRefresh(tokenExistente.refresh_token);
      this.handleLoginResponse(response);
    },
    handleLoginResponse(response) {
      if (response) {
        this.showLogin = false;
        this.email = '';
        this.password = '';
        this.id_licenca = '';
        this.$emit('close');
      }
    },
    async handleLogin() {
      if (this.$refs.loginForm.validate()) {
        const response = await this.login({ email: this.email, senha: this.password, id_licenca: this.id_licenca });
        this.handleLoginResponse(response);
      }
    },
  }
}
</script>

<style>

</style>